<template>
  <div>
    <div class="rightB">
      <img src="../assets/call1.png"
           alt=""
           class="call1"
           @mouseenter="callshow = true,emailshow=false,wxshow=false"
           @click="callshow = !callshow,emailshow=false,wxshow=false">
      <div class="line"></div>
      <img src="../assets/email1.png"
           alt=""
           class="call4"
           @mouseenter="emailshow = true,callshow=false,wxshow=false"
           @click="emailshow = !emailshow,callshow=false,wxshow=false">
      <div class="line"></div>

      <img src="../assets/wx1.png"
           alt=""
           class="call2"
           @mouseenter="wxshow = true,emailshow=false,callshow=false"
           @click="wxshow = !wxshow,emailshow=false,callshow=false">
      <div class="line"></div>
      <div class="top color-6"
            @mouseenter="wxshow = false,emailshow=false,callshow=false"
           @click="scrollToTop">
        <img src="../assets/top.png"
             alt=""
             class="call2 call3">
        <div class="topp">TOP</div>
      </div>

    </div>
    <div class="wxshow"
         @mouseleave="wxshow = false"
         v-if="wxshow == true">
      <img src="../assets/wx.png"
           alt=""
           class="wx">
      <div class="wx1">{{ $t('aside3') }}</div>
      <div class="wx2">{{ $t('aside4') }}</div>
      <div class="wx3">
        <img :src="wximg"
             alt=""
             class="wx4">
      </div>
      <div class="wx5">{{ $t('aside5') }}</div>
    </div>
    <div class="wxshow callshow"
         @mouseleave="callshow = false"
         v-if="callshow == true">
      <img src="../assets/call.png"
           alt=""
           class="wx">
      <div class="wx1">{{ $t('aside1') }}</div>
      <div class="wx2">{{ dtl.com_mobile }}</div>
    </div>
    <div class="wxshow callshow emailshow"
         @mouseleave="emailshow = false"
         v-if="emailshow == true">
      <img src="../assets/email.png"
           alt=""
           class="wx">
      <div class="wx1">{{ $t('aside2') }}</div>
      <div class="wx2">{{ dtl.com_email }}</div>
    </div>
  </div>
</template>

<script>
import { config_lxwm } from "../api/home";

export default {
  data() {
    return {
      dtl:'',
      callshow: false,
      wxshow: false,
      emailshow: false,
      yx: "",
      dh: "",
      wximg: "",
    };
  },
  created(){
    this.getDtl()
  },
  methods: {
    getDtl() {
      config_lxwm().then((res) => {
        if (res.code == 1) {
          this.dtl = res.data
          this.wximg = res.data.com_weixin
        }
      });
    },
     scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
    },
  },
};
</script>

<style scoped lang="scss">

.rightB {
  // padding: 20px 0 10px 0;
  position: fixed;
  right: 0;
  bottom: 30%;
  // width: 70px;
  // height: 350px;
  // background: #fff;
  z-index: 10;
  // border-top-left-radius: 10px;
  // border-bottom-left-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  .call1 {
    width: 30px;
    height: 30px;
    cursor: pointer;
    padding: 30px 25px;
    background: #fff;
    border-top-left-radius: 10px;
    &:hover{
      background: #0D7BE6;
    }
  }
  
  .call4{
    width: 30px;
    height: 30px;
    cursor: pointer;
    padding: 30px 25px;
    background: #fff;
    &:hover{
      background: #0D7BE6;
    }
  }
  .call2 {
    width: 35px;
    height: 35px;
    cursor: pointer;
    padding: 30px 22.5px;
    background: #fff;
    &:hover{
      background: #0D7BE6;
    }
    

  }
  .call3{
    padding: 0;
    background: transparent;
  }
  .line {
    width: 100%;
    height: 1px;
    background: #e3e3e3;
  }
  .top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    padding: 20px 22.5px;
    background: #fff;
    border-bottom-left-radius: 10px;
    &:hover{
      background: #0D7BE6;
    }


  }
}
.wxshow{
  position: fixed;
  right: 5%;
  bottom: 30%;
  padding: 15px 23px;
  background: #fff;
  box-shadow: 0px 2px 15px 0px rgba(0,0,0,0.11);
  z-index: 10;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wx{
    width: 45px;
    height: 45px;
  }
  .wx1{
    font-size: 14px;
    font-weight: bold;
    margin: 10px 0;
  }
  .wx2{
    font-size: 12px;
  }
  .wx3{
    width: 90px;
    height: 90px;
    border: 3px solid #3C97F3;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0;

  }
  .wx4{
    width: 90%;
    height: 90%;
  }
  .wx5{
    font-size: 10px;
    color: #999999;
  }
}
.callshow{
  width: 150px;
  position: fixed;
  right: 5%;
  bottom: 50%;
}
.emailshow{
  padding: 20px 30px;
  bottom: 45%;

}
@media (max-width: 1200px) {
  
  .rightB{
    display: none;
  }

  
}
</style>